import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiPaper from '@material-ui/core/Paper';
import MuiCircularProgress from '@material-ui/core/CircularProgress';

import PayeesTableRow from './payees-table-row';

const styles = () => ({
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});

const TablePayees = props => {
  const { groupId, onCreatePayee, refetch, payees, isLoading } = props;

  const [editingId, setEditingId] = useState(null);

  const handleEditRow = id => setEditingId(id);

  if (isLoading) return <MuiCircularProgress />;

  return (
    <MuiTableContainer component={MuiPaper}>
      <MuiTable aria-label="collapsible table">
        <MuiTableHead>
          <MuiTableRow>
            <MuiTableCell>id</MuiTableCell>
            <MuiTableCell>Email Address</MuiTableCell>
            <MuiTableCell>Full Name</MuiTableCell>
            <MuiTableCell>Type</MuiTableCell>
            <MuiTableCell>Group Name</MuiTableCell>
            <MuiTableCell>Account Status</MuiTableCell>
            <MuiTableCell align="right" />
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {payees?.map(row => (
            <PayeesTableRow
              key={row.id}
              row={row}
              editing={editingId === row.id}
              groupId={groupId}
              onEditChange={handleEditRow}
              onCreatePayee={onCreatePayee}
              refetchPayees={refetch}
            />
          ))}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
};

export default withStyles(styles)(withRouter(TablePayees));
